import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { ProjectService } from '../project/project.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { NotificationPolar } from '../models';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {
  emailAckId: string | null = null; // Variable to store emailAckId

  notifications: NotificationPolar[] = [];
  error;
  page = 0;
  isAllRetrieved = false;
  isFetchingData = false;
  
  isPopupVisible = false; 
  selectedNotification: NotificationPolar | null = null; 
  currentPage: number = 1;
  itemsPerPage: number = 10;
  

  name: string = '';
  kitId: string = '';
  message: string = '';
  status: string ='';
  email: string = ''; 
  userId: string = "";
  

  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute, private projectService: ProjectService,
              private spinner: NgxSpinnerService, private toaster: ToastrService, private http: HttpClient) {}

  ngOnInit() {
    this.spinner.show();
    this.getNotification(0);
  }

  getNotification(offset: number): void {
    this.isFetchingData = true;
    this.projectService.getNotificationForUser(offset).subscribe({
      next: (response) => {
        if (response.content.length < 10) {
          this.isAllRetrieved = true;
        }
        this.notifications = this.notifications.concat(response.content);
      },
      error: () => {
        this.spinner.hide();
        this.isFetchingData = false;
        this.toaster.error('Oops... Something went wrong', 'Error!');
      },
      complete: () => {
        this.spinner.hide();
        this.isFetchingData = false;
      }
    });
  }

  loadMoreAtEnd(e): void {
    if (this.bottomReached() && !this.isAllRetrieved) {
      this.getNotification(++this.page);
    }
  }

  bottomReached(): boolean {
    const element = document.getElementById('main3');
    if (!element) return false;

    const offset = element.offsetHeight;
    const scrolledHeight = element.scrollTop;
    return (offset + scrolledHeight + 1) >= element.scrollHeight;
  }

  
  openPopup(emailAckId: string, notification: NotificationPolar) {
    this.selectedNotification = notification; 
    this.emailAckId = emailAckId;
    this.fetchNotificationDetails();
    this.isPopupVisible = true; 
  }

  
  closePopup(): void {
    this.isPopupVisible = false; 
    this.selectedNotification = null;
  }

  fetchNotificationDetails(): void {
    if (this.emailAckId) {
      const apiUrl = environment.host + `/emailAck/${this.emailAckId}/get-email-ack`;

      this.http.get<any>(apiUrl).subscribe({
        next: (response) => {
          console.log('API Response:', response);
          this.name = response.name || '';
          this.kitId = response.content.kitId || '';
          this.message = response.content.message || '';
          this.status = response.content.status || '';
          this.email = response.content.email || ''; 
          this.userId = response.content.userId || "";
          
        },
        
        error: (error) => {
          console.error('Error fetching notification details:', error);
          this.toaster.error('Failed to fetch notification details. Please try again later.');
        }
      });
    } else {
      console.error('emailAckId is not defined, unable to fetch notification details');
    }
  }

  get totalPages() {
    return Math.ceil(this.notifications.length / this.itemsPerPage);
  }

  get totalPagesArray() {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  get paginatedNotifications() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.notifications.slice(startIndex, startIndex + this.itemsPerPage);
  }

  goToPage(page) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  visiblePages() {
    const maxVisiblePages = 5;
    let startPage = Math.max(1, this.currentPage - 2);
    let endPage = Math.min(this.totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage < maxVisiblePages - 1) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  }

}